"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpinDetail = exports.SpinsGrid = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();
const SpinsGrid = exports.SpinsGrid = /*#__PURE__*/(0, _react.styled)("div")({
  name: "SpinsGrid",
  class: "siqqze",
  vars: {
    "siqqze-0": [({
      columns
    }) => columns],
    "siqqze-2": [({
      isClickable
    }) => isClickable ? 'pointer' : 'unset']
  }
});
const StyledSpinDetail = exports.StyledSpinDetail = /*#__PURE__*/(0, _react.styled)("div")({
  name: "StyledSpinDetail",
  class: "s1udzzyz",
  vars: {
    "s1udzzyz-0": [({
      isExpanded
    }) => isExpanded ? 'min-content' : '0'],
    "s1udzzyz-1": [({
      columns
    }) => columns],
    "s1udzzyz-3": [({
      hideDetailRightCorner
    }) => hideDetailRightCorner ? '0' : '8px'],
    "s1udzzyz-4": [({
      hideDetailLeftCorner
    }) => hideDetailLeftCorner ? '0' : '8px']
  }
});